import InnerComponent from '@Components/Sales/Consumption/ConsumptionForm';
import orgContainer from '@Components/AppContainer';

const UpdateConsumption = () => ((orgContainer(InnerComponent)));
export default UpdateConsumption;